import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { contractModificationsWizardSteps } from 'src/app/models/wizard-enum';

@Component({
  selector: 'contract-modification-payment-amount',
  templateUrl: './payment-amount.component.html',
  styleUrls: ['./payment-amount.component.scss'],
  standalone: false,
})
export class PaymentAmountComponent {
  wizardStepsEnum = contractModificationsWizardSteps;

  @Input() contractModificationRequest: app.models.ContractModificationRequest;
  @Input() contractModificationRequestHeader: app.models.ContractModificationRequestHeader;
  @Input() thirdQuestionFormGroup: FormGroup;

  @Input() nextStepHandler: any;
}
